import React from "react";
import { Card } from "antd";
import { getPresenceScoreClass, isMonitoredDomain } from "./utils";
import { MentionedDomainMetrics } from "../types";


const { Meta } = Card;
type Props = {
    domain: string;
    topWebsitePerformances: MentionedDomainMetrics[];
}


export default function TopWebsites({ domain, topWebsitePerformances }: Props) {
    return (
        <Card
            className="top-websites"
            type="inner"
            title={
                <Meta title={"Top websites"} description={"Recommended in the AI answers"} />
            }
        >
            <ul>
                <li key={"header"}>
                    <div className="competitor-container header">
                        <div className="domain"><strong>Domain</strong></div>
                        <div className="presence-score"><strong>Score</strong></div>
                    </div>
                </li>

                {topWebsitePerformances.map((website, index) => (
                    <li key={index} className={`${isMonitoredDomain(website.domain, domain) ? "highlighted" : ""}`}>
                        <div className="competitor-container">
                            <div className="domain">
                                <img
                                    className="favicon"
                                    src={`https://www.google.com/s2/favicons?domain=${website.domain}`}
                                    width="16"
                                    height="16"
                                    alt={`favicon of ${website.domain}`}
                                    onError={(e) => {
                                        e.currentTarget.className = 'default';
                                        if (e.currentTarget.src !== '/images/default_favicon.png') {
                                            e.currentTarget.src = '/images/default_favicon.png';
                                        }
                                    }}
                                />

                                <a href={`https://${website.domain}`} rel="noopener noreferrer">{website.domain}</a>
                            </div>
                            <div className={`presence-score ${getPresenceScoreClass(website.presence_score)}`}>{website.presence_score}/100</div>
                        </div>
                    </li>
                ))}
            </ul>
        </Card>
    );
}
